const padStart = (val) => {
  return val.toString().padStart(2, '0');
};

export const posFormatter = (val) => {
  const hours = Math.floor(val / 3600);
  val %= 3600;
  const minutes = Math.floor(val / 60);
  val %= 60;

  let result = '';

  if (hours > 0) {
    result += padStart(hours) + ':';
  }

  result += `${padStart(minutes)}:${padStart(val)}`;

  return result;
};
